import React from 'react';

import { StyledHome } from './Home.styled';

import CTA from '../../components/CTA';
import Hero from '../../components/Hero';

const Home = () => {
  return (
    <StyledHome>
      <CTA />
      <Hero />
    </StyledHome>
  );
};

export default Home;
